"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.perfNow = void 0;
var win_1 = require("./win");
exports.perfNow = function () { var _a; return (((_a = win_1.win === null || win_1.win === void 0 ? void 0 : win_1.win.performance) === null || _a === void 0 ? void 0 : _a.now) ? win_1.win.performance.now() : Date.now()); };
//# sourceMappingURL=perfNow.js.map